import React from 'react'

export const LoadingSkeletonMenus = () => {
    return (
        <div role="status" className="max-w-sm animate-pulse px-2">
            {/* <div className="h-9 bg-[#618BCC]/70 w-full mb-1 rounded-lg" />
            <div className="h-8 bg-[#618BCC]/60 w-full mb-1 rounded-lg" /> */}
            <div className="h-10 bg-[#9fbdeb]/70 w-full mb-1 rounded-lg" />
            <div className="h-10 bg-[#9fbdeb]/50 w-full mb-1 rounded-lg" />
            <div className="h-10 bg-[#9fbdeb]/30 w-full mb-1 rounded-lg" />
            <div className="h-10 bg-[#9fbdeb]/20 w-full mb-1 rounded-lg" />
            <div className="h-10 bg-[#9fbdeb]/10 w-full mb-1 rounded-lg" />
            {/* <div className="h-8 bg-[#618BCC40]/30 w-full mb-1 rounded-lg" /> */}
            <span className="sr-only">Loading...</span>
        </div>

    )
}

export const LoadingSkeletonChart = () => {
    return (
        // <div role="status" className="w-56 py-6 rounded animate-pulse m-auto">
        //     <div className="flex items-baseline mt-4 gap-2">
        //         <div className="w-full bg-gray-200 rounded-t-lg h-44 ms-6" />
        //         <div className="w-full h-28 ms-6 bg-gray-200 rounded-t-lg" />
        //         <div className="w-full bg-gray-200 rounded-t-lg h-40 ms-6" />
        //         <div className="w-full h-28 ms-6 bg-gray-200 rounded-t-lg" />
        //     </div>
        //     <span className="sr-only">Loading...</span>
        // </div>
        <div role="status" className="flex loading-wave w-56 my-36 rounded animate-pulse m-auto">
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
        </div>
    )
}